import * as React from 'react';
import styles from './styles.module.css';
export var SuggestModalMobileHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "suggest-modal-mobile-header",
    className: styles['header'],
    ref: ref
  }, props.children);
});
SuggestModalMobileHeader.displayName = 'SuggestModalMobileHeader';